import {
  MultiViewCalendar,
  MultiViewCalendarChangeEvent,
  SelectionRange,
} from '@progress/kendo-react-dateinputs';
import { produce } from 'immer';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../common/widgets/Button';
import PopoverDialog from '../../../../../common/widgets/PopoverDialog';
import { resources } from '../../../resources/resources';
import { ChartPeriodModel, PeriodModel } from './types';
import { getChartPeriods, mapPeriod } from './utils';
import Icons from '../../../../../common/widgets/Icons';

interface PeriodSelectorProps {
  period: PeriodModel;
  setPeriod: (newPeriod: PeriodModel) => void;
}

export const PeriodSelector = (props: PeriodSelectorProps) => {
  const { t: translate } = useTranslation();
  const { period, setPeriod } = props;
  const [internalPeriod, setInternalPeriod] = useState<ChartPeriodModel>(
    getChartPeriods(translate)[0],
  );

  const onSaveClick = () => {
    setPeriod(mapPeriod(internalPeriod));
  };

  const setCustomPeriod = (e: MultiViewCalendarChangeEvent) => {
    setInternalPeriod(
      produce(d => {
        const value = e.value as SelectionRange;
        if (value.start) {
          const momentDate = moment(value.start);
          d.startDate = new Date(momentDate.year(), momentDate.month(), 1);
        } else {
          d.startDate = undefined;
        }
        if (value.end) {
          const momentDate = moment(value.end);
          d.endDate = new Date(
            momentDate.year(),
            momentDate.month(),
            momentDate.daysInMonth(),
          );
        } else {
          d.endDate = undefined;
        }
      }),
    );
  };

  const getCustomPeriod = (): SelectionRange => {
    return {
      start: internalPeriod.startDate ?? null,
      end: internalPeriod.endDate ?? null,
    };
  };

  const content = (
    <>
      <div className="m-period-selector-main">
        <ul className="m-period-selector-dates">
          {getChartPeriods(translate).map(e => (
            <li
              key={e.text}
              className={
                e.text === internalPeriod.text ? 'selected-active' : ''
              }
              onClick={() => setInternalPeriod(e)}
            >
              {e.text}
            </li>
          ))}
        </ul>
        <MultiViewCalendar
          disabled={!internalPeriod.isCustom}
          topView="decade"
          bottomView="year"
          mode="range"
          onChange={setCustomPeriod}
          value={getCustomPeriod()}
        />
      </div>
      <div className="m-period-selector-actions">
        <Button
          className="btn btn-solid"
          onClick={onSaveClick}
          disabled={!internalPeriod.startDate || !internalPeriod.endDate}
        >
          {translate(resources.save)}
        </Button>
      </div>
    </>
  );
  return (
    <PopoverDialog
      type="click"
      placement="bottom"
      content={content}
      arrow={false}
      maxWidth={1000}
      className="m-period-selector"
    >
      <div className="m-period-selector-btn">
        <span>{period.text}</span>
        <Icons.Calendar />
      </div>
    </PopoverDialog>
  );
};
